import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const getCompanyAction = createAsyncThunk(`${companySliceName}/getCompany`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/company", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
